import api from './api';

const state = {
	success: false,
	error: false,
	message: '',
	loading: false,
};

const getters = {};

const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
	},
	showSuccess(state) {
		state.success = true;
	},
	hideSuccess(state) {
		state.success = false;
	},
	showError(state) {
		state.error = true;
	},
	hideError(state) {
		state.error = false;
	},
	setMessage(state, { msg }) {
		state.message = msg;
	},
};

const actions = {
	createTenant({ state, dispatch, commit }, { tenant }) {
		return api
			.addTenant(tenant)
			.then(() => {
				commit('setMessage', { msg: 'Tenant successfully created' });
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				dispatch('tenant/load', null, { root: true });
			})
			.catch(err => {
				const message = err?.response.data.message;
				commit('setMessage', { msg: 'Failed to create tenant' });
				commit('showError');
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},

	deleteTenant({ state, dispatch, commit }, { tenant }) {
		return api
			.deleteTenant(tenant)
			.then(() => {
				commit('setMessage', { msg: 'Tenant successfully deleted' });
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				dispatch('tenant/load', null, { root: true });
			})
			.catch(err => {
				const message = err?.response.data.message;
				commit('setMessage', { msg: 'Failed to delete tenant' });
				commit('showError');
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},

	updateTenant({ state, dispatch, commit }, { tenant }) {
		return api
			.editTenant(tenant)
			.then(() => {
				commit('setMessage', { msg: 'Tenant successfully updated' });
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				dispatch('tenant/load', null, { root: true });
			})
			.catch(err => {
				const message = err?.response.data.message;
				commit('setMessage', { msg: 'Failed to update tenant' });
				commit('showError');
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
